<template>
    <svg class="info-icon" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M17.1539 12.6281V25.6004H14.8717V12.6281H17.1539ZM15.988 6.40039C16.4676 6.40039 16.8562 6.54808 17.1539 6.84347C17.4516 7.13885 17.6004 7.50808 17.6004 7.95116C17.6004 8.39424 17.4516 8.76347 17.1539 9.05885C16.8562 9.33783 16.4676 9.47731 15.988 9.47731C15.5249 9.47731 15.1446 9.33783 14.8469 9.05885C14.5492 8.76347 14.4004 8.39424 14.4004 7.95116C14.4004 7.50808 14.5492 7.13885 14.8469 6.84347C15.1446 6.54808 15.5249 6.40039 15.988 6.40039Z"
            fill="black" />
        <circle cx="16" cy="16" r="15.5" stroke="black" />
    </svg>
</template>
